"use client";

import { createContext } from "react";
import type { MessageType } from "../Field/Messages";

export interface FieldsetContextType {
  controlId?: string;
  messages?: MessageType[];
}

const FieldsetContext = createContext<FieldsetContextType | null>(null);

export { FieldsetContext };
